import { useMemo } from 'react';

interface Params {
  isAllowed: boolean;
  amount: number;
  organizationNames: string[];
  organizationsCount: number;
  currentOrganizationName?: string;
}

export const useUnappliedFundsBanner = ({
  isAllowed,
  amount,
  organizationNames,
  organizationsCount,
  currentOrganizationName,
}: Params) => {
  const isVisible = useMemo(() => isAllowed && amount > 0, [isAllowed, amount]);

  const isOrganizationsList = useMemo(
    () =>
      organizationsCount > 1 || (organizationsCount === 1 && organizationNames[0] !== currentOrganizationName),
    [organizationsCount, organizationNames, currentOrganizationName]
  );

  return {
    isVisible,
    isOrganizationsList,
    organizationNames,
    organizationsCount,
  };
};

export default useUnappliedFundsBanner;
